export default __webpack_public_path__ + "static/dotikimage-21f78df1e9a1a3a15e84e3f729dfe5f2.jpg";